// Format number with thousand separators
export function formatNumber(num: number): string {
  return num.toLocaleString('nl-NL')
}

// Format currency in millions
export function formatCurrency(millions: number): string {
  return `€${millions.toLocaleString('nl-NL', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} miljoen`
}
